module.exports = __webpack_public_path__ + "static/media/home.ff64f555.png";